/**
 * Created with IntelliJ IDEA.
 * User: ShaharA
 * Date: 15/01/14
 * Time: 10:34 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var _ = require('underscore');
    var Backbone = require('backbone');
    var DefaultPlusComponentItemModel = require('ui/plus-composite-view/js/models/DefaultPlusComponentItemModel');

    /**
     * DefaultPlusComponentCollection is a collection of LanguageModel - containing language code and language name
     */
    var DefaultPlusComponentCollection = Backbone.Collection.extend({
        model : DefaultPlusComponentItemModel,

        initialize: function() {

        },

        /**
         * Setup the order attribute of the models, to be used while sorting when grouping is enabled.
         * @private
         */
        _setupOrder: function() {
            var index = 0;
            this.each(function(model){
                model.set("order", index++);
            });
        }
    });

    return DefaultPlusComponentCollection;
});